module.exports = __webpack_public_path__ + "static/img/12.ec340a4f.png";